import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface UserDetails {
  _id: string;
  email: string;
  name: string;
  role: string;
  positions: [];
  exp: number;
  iat: number;
}

interface TokenResponse {
  token: string;
}

export interface TokenPayload {
  email: string;
  password: string;
  name?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private token: string;

  constructor(private http: HttpClient, private router: Router) {}

  private saveToken(token: string): void {
    localStorage.setItem('mean-token', token);
    this.token = token;
  }

  private getToken(): string {
    if (!this.token) {
      this.token = localStorage.getItem('mean-token');
    }
    return this.token;
  }

  private request(
    method: 'post' | 'get',
    type: 'login' | 'register' | 'profile' | 'adduser',
    body?: any
  ): Observable<any> {
    let base$;

    if (method === 'post') {
      // prev for registration EP
      // base$ = this.http.post(`https://hrapp1.kwhero.com/api/${type}`, user);

      // new to add user by admin
      base$ = this.http.post(`https://hrapp1.kwhero.com/api/${type}`, body, {
        headers: { Authorization: `Bearer ${this.getToken()}` }
      });

      // base$ = this.http.post(`http://localhost:3000/api/${type}`, body, {
      //   headers: { Authorization: `Bearer ${this.getToken()}` }
      // });
    } else {
      base$ = this.http.get(`https://hrapp1.kwhero.com/api/${type}`, {
        headers: { Authorization: `Bearer ${this.getToken()}` }
      });
      // base$ = this.http.get(`http://localhost:3000/api/${type}`, {
      //   headers: { Authorization: `Bearer ${this.getToken()}` }
      // });
    }

    const request = base$.pipe(
      map((data: TokenResponse) => {
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );

    return request;
  }

  public logout(): void {
    this.token = '';
    window.localStorage.removeItem('mean-token');
    this.router.navigateByUrl('/');
  }

  public getUserDetails(): UserDetails {
    const token = this.getToken();
    let payload;
    if (token) {
      payload = token.split('.')[1];
      payload = window.atob(payload);
      // console.log(JSON.parse(payload))
      return JSON.parse(payload);
    } else {
      return null;
    }
  }

  public isLoggedIn(): boolean {
    const user = this.getUserDetails();
    if (user) {
      return user.exp > Date.now() / 1000;
    } else {
      return false;
    }
  }

  public isAdmin(): boolean {
    const user = this.getUserDetails();
    if (user) {
    if (user.role === 'admin') {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
  }

  public isAdminOrSupport(): boolean {
    const user = this.getUserDetails();
    if (user) {
    if ((user.role === 'admin') || (user.role === 'support')) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
  }

  public register(user): Observable<any> {
    return this.request('post', 'register', user);
  }

  public login(user: TokenPayload): Observable<any> {
    return this.request('post', 'login', user);
  }

  public profile(): Observable<any> {
    return this.request('get', 'profile');
  }

  public addUser(user: TokenPayload): Observable<any> {
    return this.request('post', 'adduser', user);
  }
}
